import { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    this.setState({ 
      error,
      errorInfo 
    });
  }

  handleRetry = () => {
    this.setState({ 
      hasError: false,
      error: null,
      errorInfo: null 
    });
  };

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      return this.props.fallback ? (
        this.props.fallback({
          error: this.state.error,
          errorInfo: this.state.errorInfo,
          retry: this.handleRetry
        })
      ) : (
        <div className="flex justify-center items-center w-full my-16">
        <div>
              <h2 className='text-xl text-red-700  font-semibold'>Oops! Something went wrong.</h2>
          {this.props.showDetails && (
            <details className='text-red-600' style={{ whiteSpace: 'pre-wrap', marginBottom: '1rem' }}>
              <summary>Error details</summary>
              <p>{this.state.error?.toString()}</p>
              <p>{this.state.errorInfo?.componentStack}</p>
            </details>
          )}
          <div className="flex gap-3">
            <button 
              onClick={this.handleRetry}
              className="bg-orange-500 rounded-lg p-2 text-white font-medium"
            >
              Try Again
            </button>
            <button 
              onClick={() => window.location.reload()}
              className="bg-orange-500 rounded-lg p-2 text-white font-medium" 
            >
              Reload Page
            </button>
          </div>
        </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  showDetails: PropTypes.bool
};

ErrorBoundary.defaultProps = {
  showDetails: process.env.NODE_ENV !== 'production'
};

export default ErrorBoundary;